import type { PresentationOptionV2 } from 'paintscout'

/**
 * Whether a `quote` block renders as the quick-cart button rather than the estimate itself (#24058).
 *
 * Quick cart only swaps the estimate for a button on a single-page presentation. On a multi-page one
 * the quote block's page would otherwise hold nothing but that button, so the estimate embeds inline
 * there; the nav's cart drawer still follows `advanced.useCart` alone. The page count uses the same
 * `<= 1` rule as the nav's `isSinglePage` (PresentationNavContextProvider).
 *
 * Every "is this an embedded quote" decision (the block, its wrapper styles, its options) reads this,
 * so they cannot disagree about what is on screen.
 */
export function isQuoteCartButton({
  useCart,
  presentation
}: {
  useCart?: boolean
  presentation?: Pick<PresentationOptionV2, 'pages'>
}): boolean {
  return !!useCart && (presentation?.pages?.length ?? 0) <= 1
}
